import React from 'react';

const FilterBar = ({
    value,
    onChange,
    onClear,
    placeholder = 'Search...',
    className = '',
}) => {
    return (
        <div className={className}>
            <div className="input-group shadow-sm border border-secondary border-opacity-25 rounded-3 bg-white">
                <input
                    type="text"
                    className="form-control border-0 p-2"
                    placeholder={placeholder}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                />
                <button type="button" style={{ marginBottom: '0px' }} className="btn btn-outline-secondary border-start-0" disabled>
                    <i className="material-symbols-rounded">search</i>
                </button>
                {value && (
                    <button
                        type="button"
                        className="btn btn-outline-secondary border-start-0"
                        onClick={onClear}
                    >
                        <i className="material-symbols-rounded">close</i>
                    </button>
                )}
            </div>
        </div>
    );
};

export default FilterBar;
